export default __webpack_public_path__ + "locales/it/WebPlugins.json?hash=146aab42b8a13ce4c7cd7f92ee104023";